import { QueryResult, useQuery } from '@apollo/client';
import { ProjectConfig, Scalars } from '@bechtel/types';
import { GET_PROJECT_COMMODITY_TYPES } from '@bechtel/client-gql';

export function useProjectCommodityTypesQuery(
  projectId: string,
  fetchFromNetwork?: boolean
): QueryResult<{ projectConfig: ProjectConfig }> {
  const vars = { variables: { id: projectId } };
  const response = useQuery<{ projectConfig: ProjectConfig }, { id: Scalars['ID'] }>(
    GET_PROJECT_COMMODITY_TYPES,
    fetchFromNetwork
      ? {
          notifyOnNetworkStatusChange: true,
          fetchPolicy: 'network-only',
          ...vars,
        }
      : {
          notifyOnNetworkStatusChange: true,
          ...vars,
        }
  );
  return response;
}
